import React, { Component } from 'react';
import { Box, Stack, TextField, Button, ButtonGroup } from '@mui/material';

// Sélecteur de période réutilisable (B4_01) : champs « Du »/« Au » + raccourcis 7j/30j/trimestre
// + bouton « Rafraîchir », partagé entre les dashboards Funnel (B3_01) et Feedbacks (B3_02) pour
// garantir un filtre homogène. Composant présentationnel SANS état (les valeurs from/to vivent
// dans le parent — convention du repo : class components, pas de hooks).
//
// Props :
//   from, to        : bornes courantes (YYYY-MM-DD), pilotées par le parent
//   isLoading       : désactive les contrôles pendant un chargement
//   onChange(from,to): édition manuelle d'un champ date → le parent met à jour son state
//   onApplyPeriod(from,to): clic sur un raccourci → le parent met à jour son state PUIS recharge
//   onRefresh()     : soumission du formulaire / bouton « Rafraîchir »
//   actions         : nœud optionnel rendu à droite (ex. bouton « Exporter CSV »)

const DAY_MS = 24 * 60 * 60 * 1000;

// YYYY-MM-DD : valeur attendue par <input type="date"> ET borne envoyée aux endpoints (cf. dashboards).
function toInputDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// Fenêtre [aujourd'hui − N jours, aujourd'hui] pour un raccourci.
function presetRange(days) {
  const to = new Date();
  const from = new Date(to.getTime() - days * DAY_MS);
  return { from: toInputDate(from), to: toInputDate(to) };
}

const PRESETS = [
  { label: '7 j', days: 7 },
  { label: '30 j', days: 30 },
  { label: 'Trimestre', days: 90 }
];

class PeriodSelector extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();
    const { onRefresh } = this.props;
    if (onRefresh) onRefresh();
  }

  applyPreset(days) {
    const { onApplyPeriod } = this.props;
    if (!onApplyPeriod) return;
    const { from, to } = presetRange(days);
    onApplyPeriod(from, to);
  }

  render() {
    const { from, to, isLoading, onChange, actions } = this.props;
    return (
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', md: 'center' }}
        flexWrap="wrap"
        useFlexGap
      >
        <Box
          component="form"
          onSubmit={this.handleSubmit}
          sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}
        >
          <ButtonGroup size="small" variant="outlined" disabled={isLoading}>
            {PRESETS.map((p) => (
              <Button key={p.days} type="button" onClick={() => this.applyPreset(p.days)}>
                {p.label}
              </Button>
            ))}
          </ButtonGroup>
          <TextField
            label="Du"
            type="date"
            size="small"
            value={from}
            onChange={(e) => onChange && onChange(e.target.value, to)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Au"
            type="date"
            size="small"
            value={to}
            onChange={(e) => onChange && onChange(from, e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <Button type="submit" variant="contained" size="small" disabled={isLoading}>
            Rafraîchir
          </Button>
        </Box>
        {actions}
      </Stack>
    );
  }
}

export default PeriodSelector;
